import React from 'react';
import SidebarBlock from '../../_partials/SidebarBlock';
import CollectionBlockLoader from './CollectionBlock.loader';
import CollectionBlock from './CollectionBlock';
import s from './CollectionsBlock.scss';
var CollectionsBlock = function (_a) {
    var _b = _a.collections, collections = _b === void 0 ? [] : _b, parentDeviation = _a.parentDeviation, isLoading = _a.isLoading;
    if (!collections.length && !isLoading) {
        return null;
    }
    return (React.createElement(SidebarBlock, { streamKey: "collections", className: s['collection-block'], titleClassname: s['block-title'], headerClassname: s['block-header'], isLoading: isLoading },
        React.createElement("div", null,
            !isLoading &&
                collections
                    .filter(
                // backend can produce weird results...
                function (collection) {
                    return collection &&
                        collection.collection &&
                        collection.deviations &&
                        collection.deviations.length;
                })
                    .map(function (_a) {
                    var collection = _a.collection, deviations = _a.deviations;
                    return (React.createElement(CollectionBlock, { key: collection.folderId, parentDeviation: parentDeviation, collection: collection, deviations: deviations }));
                }),
            isLoading &&
                Array(4)
                    .fill(0)
                    .map(function (_, index) { return (React.createElement(CollectionBlockLoader, { key: index, parentDeviation: parentDeviation, index: index + 1 })); }))));
};
CollectionsBlock.displayName = 'CollectionsBlock';
export default CollectionsBlock;
//# sourceMappingURL=CollectionsBlock.js.map